import React from 'react'
import { useTranslation } from 'react-i18next'
import LanguageIcon from '@mui/icons-material/Language'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { LANGUAGE_STORAGE_KEY } from '../../../../i18n/i18n.config'
import { StaffLanguageButton } from '../Drawer.styled'

const LANGUAGE_OPTIONS = [
  { code: 'en', labelKey: 'header.language.english' },
  { code: 'gr', labelKey: 'header.language.greek' },
] as const

type LanguageCode = (typeof LANGUAGE_OPTIONS)[number]['code']

const StaffLanguageMenu: React.FC = () => {
  const { t, i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const currentLanguageCode: LanguageCode = i18n.language.startsWith('gr') ? 'gr' : 'en'

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = (languageCode: LanguageCode) => {
    void i18n.changeLanguage(languageCode)
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, languageCode)
    handleMenuClose()
  }

  return (
    <>
      <StaffLanguageButton
        color="inherit"
        aria-label={t('header.language.changeLanguage')}
        aria-controls={anchorEl ? 'staff-language-menu' : undefined}
        aria-haspopup="menu"
        aria-expanded={anchorEl ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        <LanguageIcon fontSize="small" />
        {currentLanguageCode.toUpperCase()}
      </StaffLanguageButton>
      <Menu id="staff-language-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {LANGUAGE_OPTIONS.map((languageOption) => (
          <MenuItem
            key={languageOption.code}
            selected={languageOption.code === currentLanguageCode}
            onClick={() => handleLanguageChange(languageOption.code)}
          >
            {t(languageOption.labelKey)}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default StaffLanguageMenu
